import React from 'react';
import { playStoreLink, appStoreLink } from 'src/app/config/appConstants';
import Images from 'src/app/static';
import { MdClose } from "react-icons/md";
import { useAppDispatch } from '../../services/store';
import { updatShowDownloadAppBanner } from 'src/shared/redux-state/src';

const DownloadAppBanner = () => {

    const dispatch = useAppDispatch();

    const handleBannerClose = () => {
        dispatch(updatShowDownloadAppBanner({ showDownloadAppBanner: false}));
    }

    const getMobileOS = () => {
        if (typeof window === "undefined") return "Other"; // Prevent errors during SSR

        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/iPad|iPhone|iPod/.test(userAgent) ||  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
            return "iOS";
        } else if (/android/i.test(userAgent)) {
            return "Android";
        }
        return "Other";
    };

    const redirectToAppStore = () => {
        const os = getMobileOS();

        if (os === 'iOS') {
            window.location.href = appStoreLink;
        } else if (os === 'Android') {
            window.location.href = playStoreLink;
        } else {
            alert('This app is only available on mobile devices.');
        }
    };

    return (
        <div className='container download-app-banner-wrapper'>
            <div className='download-app-banner-text' onClick={redirectToAppStore}>
                <img src={Images.mobileIcon} alt="mobile-icon"/>
                <p>*Stay connected with your child’s updates!* Get our mobile app now.</p>
            </div>
            <div className="banner-close-btn" onClick={handleBannerClose}>
                <MdClose />
            </div>
        </div>
    )
}   

<a href={playStoreLink} target='_blank' rel='noreferrer' className='w-50 pd-x-8'><img src={Images.googlePlay} alt="google-play" /></a>

export default DownloadAppBanner;